// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"tech_videoContainer__3dJ7p","techMovieVideo":"tech_techMovieVideo__2lOii"};